
const priceInfo = {
    english: {
        tableHead: ['Service', 'Price'],
        tableBody: [
            {
                id: 0,
                name: "Consultation",
                price: 'Free',
            },
            {
                id: 1,
                name: "Acupressure(deep tissue)",
                price: '$85/50mins',
            },
            {
                id: 2,
                name: "Acupuncture",
                price: '$110/55mins',
            },
            {
                id: 3,
                name: "Facial Acupuncture",
                price: '$110/55mins',
            },
            {
                id: 4,
                name: "TCM Consulation (Pulse Diagnosis)",
                price: '$35/time',
            },
            {
                id: 5,
                name: "TCM Medicine",
                price: 'According to diagnosis',
            },
            {
                id: 6,
                name: "Lymph Drainage Massage",
                price: '$100/75mins',
            },
            {
                id: 7,
                name: "Traditional Head Massage",
                price: '$70/50mins',
            },
            {
                id: 8,
                name: "Registered Massage Therapy",
                price: '$125/50mins',
            },
            {
                id: 9,
                name: "Cupping",
                price: '$35/time',
            },
            {
                id: 10,
                name: "Scraping",
                price: '$35/time',
            },
            {
                id: 11,
                name: "Aromatic Essential Oil Massage",
                price: '$76/50mins',
            },
            {
                id: 12,
                name: "Pediatrics Massage",
                price: '$90/50mins',
            },
            {
                id: 13,
                name: "Pregnancy Massage",
                price: '$110/75mins',
            },
            {
                id: 14,
                name: "Hot Stone Massage",
                price: '$130/75mins',
            },
            {
                id: 15,
                name: "Subsequent Visit",
                price: '$95/50mins'
            }
        ] 
    },
    chinese: {
        tableHead: ['项目', '价格'],
        tableBody: [
            {
                id: 0,
                name: "咨询",
                price: '免费',
            },
            {
                id: 1,
                name: "推拿(深度按摩）",
                price: '$85/50分钟',
            },

            {
                id: 2,
                name: "针灸(首次访问）",
                price: '$110/55分钟',
            },
            {
                id: 3,
                name: "针灸",
                price: '$60/30分钟 \n $95/50分钟 \n $135/75分钟',
            },
            {
                id: 4,
                name: "面部针灸",
                price: '$105/55分钟',
            },
            {
                id: 5,
                name: "传统中药及颗粒剂",
                price: '视处方而定',
            },
            {
                id: 6,
                name: "全身淋巴排毒",
                price: '$100/75分钟',
            },
            {
                id: 7,
                name: "头部经络疏通",
                price: '$65/50分钟',
            },
            {
                id: 8,
                name: "胸部腺体疏通疗程",
                price: '$85/50分钟',
            },
            {
                id: 9,
                name: "拔罐",
                price: '$35/次',
            },
            {
                id: 10,
                name: "刮痧",
                price: '$35/次',
            },
            {
                id: 11,
                name: "精油推拿",
                price: '$76/50分钟',
            },
            {
                id: 12,
                name: "小儿推拿",
                price: '$90/50分钟',
            },
            {
                id: 13,
                name: "孕妇按摩",
                price: '$110/75分钟',
            },
            {
                id: 14,
                name: "热石理疗",
                price: '$130/75分钟',
            },
            {
                id: 15,
                name: "脉诊",
                price: '$35/次',
            },
        ]
    }
}

export default priceInfo;